import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useAddLanguage, useUpdateLanguage } from "../hook/useSetting";
import { showToast } from "../../../utils/toastUtils";



interface selectedRowInterface{
  languagename: string;
  languagecode: number;
  LanguageId: number;
  CreatedAt: string;
}

interface LanguageTableModalContentProps {
  handleClose: () => void;
  status:string | null,
  rowData:selectedRowInterface | null;
}

interface ReqBodyInterface {
    LanguageName:string,
    LanguageCode:string
  }
interface FormDataInterface {
  languageName: string;
  languageCode: string;

}

const LanguageTableModalContent: React.FC<LanguageTableModalContentProps> = ({
  handleClose,
  status,
  rowData
}) => {
  
  useEffect(()=>{
    if(status ==='Edit'){
       setFormData((prev:any)=>({
          ...prev,
          languageName:rowData?.languagename,
          languageCode:rowData?.languagecode,
       })) 
   }
       
  },[status])

  const {mutate:addLanguage} = useAddLanguage();
  const {mutate:updateLanguage}  = useUpdateLanguage();

  const handleSubmit =(e: React.FormEvent)=>{
     e.preventDefault();

     const Reqbody:ReqBodyInterface={
        LanguageName:formData.languageName,
        LanguageCode:formData.languageCode
     }
     if(status =="Add"){
        if(formData.languageName === ''){
          showToast.warning("Empty string can not be accept")
          return;
        }
        addLanguage(Reqbody);
     }
    if(status ==="Edit"){
       const ID = Number(rowData?.LanguageId);
       updateLanguage({ReqBody:Reqbody,id:ID});
     }
     handleClose();
     setFormData(initialFormData);

  }
 
    const initialFormData: FormDataInterface = {
    languageName: '',
    languageCode: '',
  };
  
  const [formData, setFormData] = useState<FormDataInterface>(initialFormData);

  const  handleChange =(field:keyof FormDataInterface,value:any)=>{

    setFormData((prev:any)=>({
      ...prev,
      [field]:value

    }))
  }


  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-12">
          <label style={{ fontWeight: "500" }}>Language Name<span style={{color:'red'}}>*</span> </label>
          <input
            required
            type="text"
            className="form-control"
            value={formData.languageName}
            placeholder="Enter category name"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleChange('languageName',e.target.value)}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
        <label style={{fontWeight: "500" }}>Language Code<span style={{color:'red'}}>*</span></label>
          <input
            required
            type="text"
            className="form-control"
            value={formData.languageCode}
            placeholder="Enter Language code"
            onChange={(e:React.ChangeEvent<HTMLInputElement>)=>handleChange('languageCode',e.target.value)}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          Submit
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default LanguageTableModalContent;
